import { useCapabilitiesStore } from '@/stores/capabilities'
import { useRoomStore } from '@/stores/room'
import { useMemo } from 'react'

/**
 * Returns whether the corresponding button should be visible and enabled
 * based on the capabilities and the current state
 * - button `visible` if one of the `capabilities` is enabled
 * - button `enabled` if the current state matches the `capability` state
 * i.e. (currently muted and can unmute) or (currently unmute and can mute)
 */
export const useAllMemberMicrophoneButtonState = () => {
  const members = useRoomStore(s => Array.from(s.membersMap.values()))

  const memberMicrophoneCapabilityOff = useCapabilitiesStore(
    state => state.memberMicrophoneCapabilityOff,
  )
  const memberMicrophoneCapabilityOn = useCapabilitiesStore(
    state => state.memberMicrophoneCapabilityOn,
  )

  const isAllMembersMuted = useMemo(
    () => members.length > 0 && members.every(m => m.audioMuted),
    [members],
  )

  // button visible if one of the capabilities is enabled
  const isMicrophoneButtonVisible =
    memberMicrophoneCapabilityOn || memberMicrophoneCapabilityOff

  // muted and can unmute
  const canUnmute = isAllMembersMuted && memberMicrophoneCapabilityOn
  // unmuted and can mute
  const canMute = !isAllMembersMuted && memberMicrophoneCapabilityOff

  // check if button can perform the necessary next action
  const isMicrophoneEnabled = canUnmute || canMute

  return {
    isAllMembersMuted,
    isMicrophoneButtonVisible,
    isMicrophoneEnabled,
  }
}
